import {
	Box,
	Typography,
	TextField,
	Checkbox,
	FormControlLabel,
	Button,
	Grid,
	Paper,
	Divider,
	FormGroup,
	FormControl,
	RadioGroup,
	Radio,
	CircularProgress,
	Stack,
	FormHelperText,
	Modal,
	List,
	ListItem,
	ListItemText
} from '@mui/material';
import React, { useEffect, useState } from "react"
import { useLang } from '../../language';
import { BreadCrumbCustom } from '../../components/BreadCrumbCustom/BreadCrumbCustom';
import { useForm } from '../../hooks/useForm';
import { OtecServices } from '../../controllers/services/otec.services'
import { OtecAdapters } from '../../controllers/adapters/otec.adapters'
import { InputText } from '../../components/Inputs/InputText';
import { useValidator } from '../../hooks/useValidator';
import { validExiste } from '../../helpers';
import { Firma } from './Firma';
import { ModalStatusServer } from '../../components/ModalStatus/ModalStatusServer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PdfModal } from './ModalPdf'
import { FormSolicitud } from './FormSolicitud'
import { DetalleSolicitud } from './DetalleSolicitud'

export const SolicitudOtec = () => {

	const Lang = useLang()

	const { fetchData: fetchParams, data: params, loading: loadingParams } = OtecServices.GET_PARAMETROS();
	const { fetchData: fetchDatosPersonales, data: datosCliente, loading: loadingCliente } = OtecServices.POST_DATOS_PERSONALES();
	const { fetchData: fetchGuardarSolictud, data: datosEnvioSolicitud, loading: loadingSolicitud, error: errorEnvioSolicitud, resetState: resetStateDatosSolicitud } = OtecServices.POST_GUARDAR_SOLICITUD();
	
	const BreadcrumbLineItems = [
		{
			title: Lang('SOLICITUD_OTED'),
			link: '/solicitud-Colegiacion-etec'
		}
	]

	const [solicitudState, setSolicitudState] = useState<any>(null);
	const [solicitudId, setSolicitudId] = useState<any>(null);

	const [formSolicitudOtc, handleInputSolicitudOtc, handleFormSolicitudOtc, handleResetFormSolicitudOtc] = useForm({
		...OtecAdapters.POST_OBTENER_DATOS_SOLICITUD.receive.schema({})
	})

	const [validOTEC, handleValidationOTEC] = useValidator({
		telefono_contacto: [
			{ functionValid: validExiste, msgError: Lang('VALID_EXISTE_CAMPO_DEFAULT'), isOk: true },
		],
		correo: [
			{ functionValid: validExiste, msgError: Lang('VALID_EXISTE_CAMPO_DEFAULT'), isOk: true },
		],
	})

	const [actividadesError, setActividadesError] = useState(false)
	const [openErrorModal, setOpenErrorModal] = useState(false);
	const [errorMessages, setErrorMessages] = useState<string[]>([]);

	let errores: string[] = [];

	const handleGuardarSolictudSubmit = (e: any) => {
		e.preventDefault();
		const erroresProyectos = validateProyectos(formSolicitudOtc.proyectos, params?.data?.proyecto);
		if (erroresProyectos.length > 0) {
			setErrorMessages(erroresProyectos);
			setOpenErrorModal(true);
			return;
		}

		fetchGuardarSolictud({
			body: {
				...formSolicitudOtc,
				accion: 'generar_documento'
			}
		})
	};

	useEffect(() => {
		if (errorEnvioSolicitud?.errors) {
			Object.entries(errorEnvioSolicitud.errors).forEach(([campo, mensajes]) => {
				if (Array.isArray(mensajes)) {
					errores.push(...mensajes);
				}
			});

			if (errores.length > 0) {
				setErrorMessages(errores);
				setOpenErrorModal(true);
				return;
			}

		}
	}, [errorEnvioSolicitud])

	useEffect(() => {
		fetchParams({
			params: {
				accion: 'obtener_parametros'
			}
		})

		fetchDatosPersonales({
			body: {
				accion: 'obtener_datos'
			}
		})
	}, []);

	const [ready, setReady] = useState(false);

	useEffect(() => {
		if (datosCliente) {
			handleFormSolicitudOtc({
				...formSolicitudOtc,
				...datosCliente
			});
			setSolicitudState(datosCliente?.estado);
			setSolicitudId(datosCliente?.id);
			setReady(true);
		}
	}, [datosCliente])

	const validateProyectos = (proyectosSeleccionados: number[], proyectoData: any) => {
		let errores: string[] = [];

		const grupos = [
			'projectes_de_generaci_d_energia_renovable',
			'projectes_de_mobilitat_el_ctrica',
			'projectes_d_efici_ncia_energ_tica',
			'tr_mits_permisos_subvencions'
		];

		grupos.forEach(grupoKey => {
			const grupo = proyectoData[grupoKey];
			if (!grupo) return;

			const padreId = Number(grupo.id_parametro);
			const padreMarcado = proyectosSeleccionados.includes(padreId);
			const hijos = grupo.hijos ? Object.values(grupo.hijos) : [];
			const hijosMarcados = hijos.filter((hijo: any) =>
				proyectosSeleccionados.includes(Number(hijo.id_parametro))
			);

			if (!padreMarcado) {
				return;
			}

			if (grupoKey === 'projectes_de_generaci_d_energia_renovable') {
				if (hijosMarcados.length === 0) {
					errores.push(`${Lang('DEBE_SELECCIONAR_PROYECTO')} "${grupo.valor}" ${Lang('ALMENOS_UN_HIJO')}.`);
				}
				return;
			}

			if (hijos.length > 0) {
				const padreSoloLectura = grupo.solo_lectura === "1";

				if (padreSoloLectura) {
					if (hijosMarcados.length === 0) {
						errores.push(`${Lang('SELECCIONAR_UN_GRUPO')} "${grupo.valor}".`);
					}
				} else {
					if (hijosMarcados.length === 0) {
						errores.push(`${Lang('DEBE_SELECCIONAR_PROYECTO')} "${grupo.valor}" ${Lang('ALMENOS_UN_HIJO')}.`);
					}
				}
			}
		});

		return errores;
	};


	/*
	const validateProyectos = (proyectosSeleccionados: number[], proyectoData: any) => {
		let errores: string[] = [];

		const grupos = [
			'projectes_de_generaci_d_energia_renovable',
			'projectes_de_mobilitat_el_ctrica',
			'projectes_d_efici_ncia_energ_tica',
			'tr_mits_permisos_subvencions'
		];

		grupos.forEach(grupoKey => {
			const grupo = proyectoData[grupoKey];
			if (!grupo) return;

			const padreId = grupo.id_parametro;
			const hijos = grupo.hijos ? Object.values(grupo.hijos) : [];

			// Casos especiales
			if (grupoKey === 'projectes_de_generaci_d_energia_renovable') {
				// Solo hijos: validar que al menos uno esté marcado
				const hijosMarcados = hijos.filter((hijo: any) =>
					proyectosSeleccionados.includes(Number(hijo.id_parametro))
				);
				if (hijosMarcados.length === 0) {
					errores.push(`${Lang('DEBE_SELECCIONAR_PROYECTO')} "${grupo.valor}".`);
				}
				return;
			}

			// Si hay hijos
			if (hijos.length > 0) {
				const hijosMarcados = hijos.filter((hijo: any) =>
					proyectosSeleccionados.includes(Number(hijo.id_parametro))
				);

				const padreSoloLectura = grupo.solo_lectura === "1";

				if ((padreSoloLectura && hijosMarcados.length === 0) ||
					(!padreSoloLectura && (!proyectosSeleccionados.includes(Number(padreId)) || hijosMarcados.length === 0))) {
					errores.push(
						padreSoloLectura
							? `${Lang('SELECCIONAR_UN_GRUPO')} "${grupo.valor}".`
							: `${Lang('DEBE_SELECCIONAR_PROYECTO')} "${grupo.valor}" ${Lang('ALMENOS_UN_HIJO')}.`
					);
				}
			} else {
				// Solo padre sin hijos
				if (!proyectosSeleccionados.includes(Number(padreId))) {
					errores.push(`${Lang('DEBE_SELECCIONAR_PROYECTO')} "${grupo.valor}".`);
				}
			}
		});

		return errores;
	};*/

	useEffect(() => {
		if(datosEnvioSolicitud?.data){
			setSolicitudState(datosEnvioSolicitud?.data?.pdf?.estado);
			setSolicitudId(datosEnvioSolicitud?.data?.id);
		}
	}, [datosEnvioSolicitud])

	return (
		<div>
			<BreadCrumbCustom items={BreadcrumbLineItems} />
			<section className='LayoutPrimary__contentmain'>
				{/*JSON.stringify(datosCliente?.id)*/}
				<Box sx={{ width: "100%" }}>
				  {loadingParams || loadingCliente ? (
					  <Grid container spacing={3} justifyContent="center">
					    <Grid item xs={12} lg={12} xl={11} className="mb-4 pb-2 xxl-8">
					      <Paper className="p-3 p-md-4">
					        <Typography
					          variant="h6"
					          className="my-0 pb-2 fw-500 color-primary text-center"
					        >
					          {Lang("MENSAJE_LOADING_SOLICITUD_OTED")}
					        </Typography>
					        <Box
					          sx={{
					            display: "flex",
					            justifyContent: "center",
					            alignItems: "center",
					            minHeight: 200,
					          }}
					        >
					          <CircularProgress size={35} thickness={4} sx={{ color: "#000000" }} />
					        </Box>
					      </Paper>
					    </Grid>
					  </Grid>
					) : (
					  <>
					    {["pendiente_verificacion", "activo", "baja"].includes(solicitudState) ? (
					      <DetalleSolicitud
					        datosCliente={datosCliente}
					        solicitudState={solicitudState}
					        setSolicitudState={setSolicitudState}
					        fetchDatosPersonales={fetchDatosPersonales}
					      />
					    ) : (ready || solicitudState === "pendiente_firma") ? (
					      <FormSolicitud
					        params={params}
					        solicitudId={solicitudId}
					        loadingParams={loadingParams}
					        loadingCliente={loadingCliente}
					        formSolicitudOtc={formSolicitudOtc}
					        handleInputSolicitudOtc={handleInputSolicitudOtc}
					        errorEnvioSolicitud={errorEnvioSolicitud}
					        validOTEC={validOTEC}
					        handleFormSolicitudOtc={handleFormSolicitudOtc}
					        handleGuardarSolictudSubmit={handleGuardarSolictudSubmit}
					        loadingSolicitud={loadingSolicitud}
					      />
					    ) : null}
					  </>
					)}

				</Box>
			</section>

			<Modal
				open={openErrorModal}
				onClose={() => setOpenErrorModal(false)}
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
					p: 2
				}}
			>
				<Box
					sx={{
						p: 3,
						bgcolor: "background.paper",
						borderRadius: 2,
						maxWidth: 500,
						width: "100%",
						maxHeight: "80vh",
						overflowY: "auto",
						boxShadow: 24
					}}
				>
					<Typography variant="h6" className="mb-2 fw-500 color-primary">
						{Lang('ERRORES_DE_VALIDACION')}
					</Typography>

					<Typography
						variant="body2"
						sx={{ mb: 2, color: "text.secondary" }}
					>
						{Lang('P_ERRORES_DE_VALIDACION_1')}
					</Typography>

					<List dense>
						{errorMessages.map((msg, idx) => (
							<React.Fragment key={idx}>
								<ListItem sx={{ py: 1, px: 2 }}>
									<ListItemText
										primaryTypographyProps={{
											variant: "body2",
											color: "error.main",
											fontWeight: 500
										}}
										primary={msg}
									/>
								</ListItem>
								{idx < errorMessages.length - 1 && (
									<Divider component="li" sx={{ my: 0.5 }} />
								)}
							</React.Fragment>
						))}
					</List>

					<section className="ModalFooter border-0 d-flex justify-content-between mt-2">
						<div></div>
						<Button
							variant="outlined"
							onClick={() => setOpenErrorModal(false)}
							sx={{ mt: 2 }}
						>
							{Lang('CERRAR')}
						</Button>
					</section>
				</Box>
			</Modal>

			<PdfModal
				data={datosEnvioSolicitud?.data}
				solicitudState={solicitudState}
				setSolicitudState={setSolicitudState}
				fetchDatosPersonales={fetchDatosPersonales}
			/>
		</div >
	);
}